import React from "react";
import { SdfIcon } from "@waypoint/react-components";

import AssistBackground from "./AssistBackground.svg";
import "./Assist.scss";

const AssistIcon = ({ className }) => {
  const fullClassName = `relative text-alert-info h-full text-heading-05${
    className ? ` ${className}` : ""
  }`;

  return (
    <div className={fullClassName}>
      <img src={AssistBackground} alt="Assist Background" className="absolute inset-0" />
      <SdfIcon icon="brand-adp-assist" className="relative" />
    </div>
  );
};

export default AssistIcon;